<script lang="ts">
	import DeviceDetector from 'svelte-device-detector';
	import { Marquee } from '$lib/components/Global/Marquee';
	import asisa from '$lib/assets/images/partners/asisa.svg';
	import april from '$lib/assets/images/partners/april.svg';
	import metlife from '$lib/assets/images/partners/metlife.svg';
	import prevoir from '$lib/assets/images/partners/prevoir.svg';
	import realvidaseguros from '$lib/assets/images/partners/realvidaseguros.png';
	import generaliTranquilidade from '$lib/assets/images/partners/generali-tranquilidade.svg';
	import allianz from '$lib/assets/images/partners/allianz.svg';

	const partners = [
		{ asisa: asisa },
		{ april: april },
		{ metlife: metlife },
		{ prevoir: prevoir },
		{ realvidaseguros: realvidaseguros },
		{ generaliTranquilidade },
		{ allianz }
	];
</script>

<div class="bg-light">
	<div class="container mx-auto py-24 lg:py-32">
		<div class="grid items-center justify-center gap-32 grayscale lg:grid-cols-5 lg:gap-16">
			<DeviceDetector showInDevice="desktop">
				{#each partners as partner, key}
					<img class="" src={Object.values(partner)[0]} alt={Object.keys(partner)[0]} />
				{/each}
			</DeviceDetector>
			<DeviceDetector showInDevice={['mobile', 'tablet']}>
				<Marquee class="gap-16 grayscale" speed="20s">
					{#each partners as partner, key}
						<img class="" src={Object.values(partner)[0]} alt={Object.keys(partner)[0]} />
					{/each}
					{#each partners as partner, key}
						<img class="" src={Object.values(partner)[0]} alt={Object.keys(partner)[0]} />
					{/each}
					{#each partners as partner, key}
						<img class="" src={Object.values(partner)[0]} alt={Object.keys(partner)[0]} />
					{/each}
					{#each partners as partner, key}
						<img class="" src={Object.values(partner)[0]} alt={Object.keys(partner)[0]} />
					{/each}
				</Marquee>
			</DeviceDetector>
		</div>
	</div>
</div>
